<template>
    <div>
        <div class="horizontal" style="align-items: center;">
            <div v-bind:class="{ 'long-cont': true, 'long-cont-grayed': vmodel, 'no-margin': noMargin, 'no-pad': noPadding}">
                <label class="long-cb-cont mt-4 mb-1" :for="label">
                    <input type="checkbox" :id="label" value="label" v-model="vmodel" @change="changed" >
                    <span class="long-checkmark" :style="checkboxError.length != 0 ? 'border: 2px solid #FD8282 !important;' : ''"></span>
                    <p style="margin-bottom: 0px; color: white;">{{ $t(label) }}</p>
                </label>
                <span v-if="checkboxError.length != 0" class="error">{{ checkboxError }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['onChange'],
    props: {
        label: {

        },
        checkModel: {

        },
        color: {

        },
        noMargin: {

        },
        tooltipText: {

        },
        noPadding: {

        },
        checkboxError: {

        }
    },
    data() {
        return {
            vmodel: null,
        }
    },
    watch: {
        checkModel(newValue, oldValue) {
            this.vmodel = newValue
            if (document.getElementById(this.label) != null) {
                document.getElementById(this.label).checked = newValue
            }
        },
    },
    methods: {
        changed() {
            this.$emit('onChange', this.vmodel)
        },
    },
    async mounted() {
        this.vmodel = this.checkModel
    }
}
</script>

<style>
.long-cont {
    /* margin: 10px; */
    min-width: 200px;
    padding: 10px;
    border-radius: 5px;
}

.long-cont.no-margin {
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 0;
    min-width: unset;
}

.long-cont.no-pad{
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 5px;
}

.long-cont-grayed {
    /* background-color: #1988A8; */
    color: white;
}

.long-cb-cont {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.long-cont > label {
    margin-bottom: 0px;
    line-height: 25px;
}

.long-cb-cont input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.long-checkmark {
    color: white;
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border: 1px solid white;
    border-radius: 5px;
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.long-cb-cont input:checked ~ .long-checkmark {
    background-color: white ;
}

.long-cb-cont:hover input ~ .long-checkmark {
    border: 1px solid white;
    background-color: rgba(255, 255, 255, 0.4);
}

.long-checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.long-cb-cont input:checked ~ .long-checkmark:after {
    display: block;
}

.long-cb-cont .long-checkmark:after {
    left: 8px;
    top: 2px;
    width: 7px;
    height: 15px;
    border: solid black;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.color-box {
    border: solid 1px black;
    border-radius: 5px;
    height: 25px;
    width: 25px;
}

.tippy-tooltip.customTheme-theme {
    background-color: #346F8B;
    text-align: left;
    font-size: 16px;
}

.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
    border-left: 8px solid #346F8B;
}

.error {
        text-align: left !important;
        color: #FD8282;
        font-size: 11px;
        font-weight: bold;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/CheckBoxCrfi.vue